// Esquema de columnas fijas para cada tipo de renovacion
export const COLUMNS_SCHEMA = {
  M2M: [
    { excelLabel: 'PEDIDO',            getValue: (row)       => row.order_id },
    { excelLabel: 'UUID',              getValue: (row)       => row.uuid },
    { excelLabel: 'INSTALACION',       getValue: (row, maps) => maps.deviceNameMap.get(row.uuid) || '' },
    { excelLabel: 'FECHA FIN',         getValue: (row)       => row.date_to_renew },
    { excelLabel: 'ICC',               getValue: (row)       => row.icc || '' },
    { excelLabel: 'ORGANIZACION',      getValue: (row)       => row.tenant_name },
    { excelLabel: 'TARIFA CONTRATADA', getValue: (row, maps) => maps.poolNameMap.get(row.icc) || '' },
  ],
  PLAN: [
    { excelLabel: 'PEDIDO',          getValue: (row)       => row.order_id },
    { excelLabel: 'UUID',            getValue: (row)       => row.uuid },
    { excelLabel: 'INSTALACION',     getValue: (row, maps) => maps.deviceNameMap.get(row.uuid) || '' },
    { excelLabel: 'FECHA FIN',       getValue: (row)       => row.date_to_renew },
    { excelLabel: 'ORGANIZACION',    getValue: (row)       => row.tenant_name },
    { excelLabel: 'PLAN CONTRATADO', getValue: (row)       => row.ki_subscription_name || '' },
  ],
};

// Esquema de columnas opcionales, con informacion para el modal ademas de para el excel. 
export const EXTRA_COLUMNS_CONFIG = [
  { key: 'descripcion',      label: 'Descripción comercial',  excelLabel: 'DESCRIPCION COMERCIAL',  getValue: (row) => row.descripcion      || '' },
  { key: 'nserie_comercial', label: 'Nº serie comercial',     excelLabel: 'NSERIE COMERCIAL',       getValue: (row) => row.nserie_comercial || '' },
];


/**
 * Construye una fila para Excel, enriqueciendo a partir de los maps, aplicando
 * el esquema del tipo y añadiendo las columnas opcionales si proceden.
 */
function buildRow(row, extraColumns, maps) {
  const type   = row.subscription_type?.toUpperCase();
  const schema = COLUMNS_SCHEMA[type] ?? COLUMNS_SCHEMA.PLAN;
  
  const obj    = {};

  schema.forEach(col => { 
    obj[col.excelLabel] = col.getValue(row, maps); 
  });

  // Columnas extra: solo las que el usuario seleccionó en el modal
  EXTRA_COLUMNS_CONFIG
    .filter(col => extraColumns.includes(col.key))
    .forEach(col => { obj[col.excelLabel] = col.getValue(row); });

  return obj;
}

/**
 * Prepara el "paquete" final para el export a Excel: nombre de fichero y
 * estructura de hojas (una sola si el dataset es de un único tipo, o una
 * hoja por tipo si hay mezcla).
 *
 * @param {Array<Object>} data Filas enriquecidas devueltas por getExportData
 * @param {Array<String>} extraColumns Columnas opcionales seleccionadas en el modal
 * @param {String} from Fecha inicial en formato YYYY-MM-DD ('' si no hay rango)
 * @param {String} to Fecha final en formato YYYY-MM-DD ('' si no hay rango)
 * @returns {{ fileName: String, sheetsData: Array<Object>|Array<{name,data}> }}
 */
export function buildExportPackage(data, extraColumns, from, to, maps) {
  // Detecta los tipos: M2M, PLAN o AMBOS
  const types      = [...new Set(data.map(r => r.subscription_type?.toUpperCase()).filter(Boolean))];
  // Usa los tipos y rango de fechas para dar nombre al documento
  const typesLabel = types.length > 0 ? types.join('_') : 'EMPTY';
  const fileName   = from === '' ? typesLabel : `${typesLabel} - ${from}-${to}`;

  // 1 hoja si hay un solo tipo, 2 hojas si hay mezcla 
  const sheetsData = types.map(type => ({
    name: type,
    data: data.filter(r => r.subscription_type?.toUpperCase() === type).map(r => buildRow(r, extraColumns, maps)),
  }));

  return { fileName, sheetsData };
}
